import { createApiCall } from 'lib/base';

const POST_COMPANY_SELL_ORDER_API_ID = 'FLEX/POST_COMPANY_SELL_ORDER_API_ID';

const apiCall = createApiCall(
  POST_COMPANY_SELL_ORDER_API_ID,
  ({ id, payload }) => ({
    endpoint: `/api/admin/employee-programs/${id}/create-company-sell-order`,
    method: 'POST',
    body: payload,
    isStay: true,
    notify: true,
  })
);

export default apiCall;
